import { Quote } from "lucide-react";
import Reveal from "@/components/Reveal";

const AVIS_VEDETTE = {
  text: "Je voulais te remercier du plus profond de mon âme : je n'ai plus aucune douleur, vraiment plus du tout. Tu viens de me libérer de 8 jours de douleurs intenses. Crois en toi, tu as de l'or entre les mains.",
  source: "Message reçu d'une coach sportive, après une séance",
};

const AVIS = [
  {
    text: "Depuis le 1er juin, et suite à mon rendez-vous avec Mme Sissan, je « revis » ! Mes douleurs ont disparu et j'ai retrouvé une démarche normale, je me tiens droite ! Merci infiniment pour cette séance d'ostéopathie et j'envisage très sérieusement que je puisse bénéficier de ses séances régulièrement !",
    source: "Une patiente, quelques jours après sa séance",
  },
  {
    text: "Petit retour sur nos séances de vendredi ! Alors oui, nous étions très fatiguées l'après midi, mais de mon côté ça m'a fait beaucoup de bien.",
    source: "Une maman venue consulter avec son bébé",
  },
  {
    text: "Je n'ai plus du tout mal, ni aux côtes ni ailleurs.",
    source: "Un patient, au lendemain de sa séance",
  },
  {
    text: "Je n'ai plus de douleur particulière au cou. J'arrive de nouveau à bien tourner la tête dans tous les sens.",
    source: "Une patiente suivie pour cervicalgies",
  },
  {
    text: "Au bout de 48 heures, comme le docteur l'avait prévu, les douleurs ont disparu et le patient a repris une activité normale.",
    source: "Un papa venu consulter pour son fils de 6 ans",
  },
  {
    text: "Impeccable !! À bientôt pour une nouvelle séance !",
    source: "Une patiente, par email",
  },
  {
    text: "Mme Sissan a pu me permettre de me mobiliser correctement dès la fin de la séance. En 2 jours je n'avais plus rien. Je recommande cette ostéo et j'en ai vu pas mal depuis quelques années.",
    source: "Une patiente, après sa première séance",
  },
  {
    text: "Merci infiniment, vous m'avez soulagé, c'est limite hallucinant l'évolution de la douleur, qui a complètement disparu. Encore merci !",
    source: "Un patient, après sa séance",
  },
  {
    text: "Beaucoup mieux ! Trapèzes détendus et cervicales qui ne se bloquent pas après le travail :)",
    source: "Une patiente, active au quotidien",
  },
  {
    text: "Très satisfaite. Mes douleurs au niveau du cou ont considérablement diminué. De jour en jour je vais mieux.",
    source: "Une patiente, douleurs du cou",
  },
  {
    text: "Une amélioration de mes tensions et déblocage des cervicales.",
    source: "Un patient, suivi pour cervicalgies",
  },
  {
    text: "Suite à ma séance d'ostéo, la douleur s'est beaucoup diminuée. Un grand merci.",
    source: "Un patient, après sa séance",
  },
];

const Avis = () => (
  <section id="avis" className="grain relative overflow-hidden bg-beige-cream py-28 md:py-36" data-testid="avis-section">
    <div aria-hidden="true" className="wash wash-sage-light blob -left-[12%] top-[10%] h-[520px] w-[520px]" />
    <div className="relative mx-auto max-w-7xl px-6 lg:px-12">
      <Reveal className="max-w-2xl">
        <p className="text-xs font-medium uppercase tracking-[0.28em] text-gold">Quelques avis</p>
        <h2 className="mt-5 font-serif text-4xl font-light leading-tight tracking-tight text-anthracite md:text-5xl">
          Ce qu'ils m'écrivent <em className="text-sage-dark">après la séance</em>
        </h2>
        <p className="mt-6 text-base font-light leading-relaxed text-taupe">
          Des messages reçus par SMS ou email, partagés ici anonymement, avec
          leur accord tacite et toute ma gratitude.
        </p>
      </Reveal>

      <Reveal delay={0.1}>
        <figure className="relative mt-16 rounded-xl border border-sage-light/60 bg-ivory p-10 md:p-14" data-testid="avis-vedette">
          <Quote className="absolute -top-5 left-10 h-10 w-10 rounded-full bg-beige-cream p-2 text-gold" strokeWidth={1} />
          <blockquote className="font-serif text-2xl font-light italic leading-relaxed text-anthracite md:text-3xl">
            « {AVIS_VEDETTE.text} »
          </blockquote>
          <figcaption className="mt-8 flex items-center gap-4">
            <span className="gold-rule w-12" />
            <span className="text-[11px] font-medium uppercase tracking-[0.22em] text-taupe/80">
              {AVIS_VEDETTE.source}
            </span>
          </figcaption>
        </figure>
      </Reveal>

      <div className="mt-8 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {AVIS.map((a, i) => (
          <Reveal key={i} delay={0.1 + i * 0.07}>
            <figure
              data-testid={`avis-card-${i}`}
              className="flex h-full flex-col justify-between rounded-xl border border-ivory/80 bg-ivory/85 p-8 backdrop-blur-sm transition-all duration-500 hover:-translate-y-1 hover:border-gold/40"
            >
              <blockquote className="font-serif text-lg font-light italic leading-relaxed text-anthracite md:text-xl">
                « {a.text} »
              </blockquote>
              <figcaption className="mt-6 flex items-center gap-4">
                <span className="gold-rule w-10" />
                <span className="text-[10px] font-medium uppercase tracking-[0.22em] text-taupe/80">{a.source}</span>
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Avis;
